import { render, staticRenderFns } from "./TrainingSessionMaterialModal.vue?vue&type=template&id=5521f7ae&scoped=true"
import script from "./TrainingSessionMaterialModal.vue?vue&type=script&lang=js"
export * from "./TrainingSessionMaterialModal.vue?vue&type=script&lang=js"
import style0 from "./TrainingSessionMaterialModal.vue?vue&type=style&index=0&id=5521f7ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5521f7ae",
  null
  
)

export default component.exports